// Reference
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl

// https://en.wikipedia.org/wiki/ISO_4217
export enum CurrencyCode {
  UnitedStatesDollar = 'USD',
  Euro = 'EUR',
  PoundSterling = 'GBP',
  JapaneseYen = 'JPY',
}

export type CurrencyDisplay = 'symbol' | 'narrowSymbol' | 'code' | 'name';

export enum WeightUnit {
  Ounce = 'oz',
  Pound = 'lb',
  Gram = 'g',
  Kilogram = 'kg',
}
